/**
 * 无人运营侧栏（Overseas patch 216）
 */
export const STORE_AUTOPILOT_MENU_IDS = {
  group: 990190,
  exceptions: 990191,
  exceptionsView: 990192
}

export default STORE_AUTOPILOT_MENU_IDS



// WEBPACK FOOTER //
// ./src/constants/storeAutopilot.js